import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Employee from 'src/app/model/product/employee';
import { Adjustment } from 'src/app/model/project/adjustment';
import { Project } from 'src/app/model/project/project';
import { SetAdjustmentNeedsDesignControllerRequestService } from './set-adjustment-needs-design-controller-request.service';
import { EmployeeChoicesService } from 'src/app/services/employee-choices.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'client-adjustment-design-dialog',
  templateUrl: './client-adjustment-design-dialog.component.html',
  styleUrls: ['./client-adjustment-design-dialog.component.scss']
})
export class ClientAdjustmentDesignDialogComponent
  extends SubscriptionBasedComponent
  implements OnInit {
  @Input()
  project: Project;
  @Input()
  adjustment: Adjustment;
  @Output()
  close = new EventEmitter<boolean>();

  designerChoices: Employee[] = [];

  selectedDesigner: Employee;
  selectedDeadline: Date;
  needsDesignDescription: string;

  submitting: boolean = false;

  constructor(
    private employeeChoicesService: EmployeeChoicesService,
    private setAdjustmentNeedsDesignControllerRequestService: SetAdjustmentNeedsDesignControllerRequestService
  ) {
    super();
  }

  ngOnInit(): void {
    this.employeeChoicesService.updateDesignerEmployees();
    this.initializeFromAdjustment();

    this.addSubscription(
      this.employeeChoicesService.getDesignerChoicesSubscribable(),
      (designers: Employee[]) => {
        this.designerChoices = designers;
      }
    );
  }

  private initializeFromAdjustment(): void {
    this.selectedDesigner = this.adjustment.adjustmentDesigner;
    this.selectedDeadline = this.adjustment.currentDesignDate;
    this.needsDesignDescription = this.adjustment.extraInfoDesign;
  }

  needsDesignDescriptionChanged(value: string): void {
    this.needsDesignDescription = value;
  }

  closeDialog(): void {
    this.close.emit(false);
  }

  async confirmNeedsDesign(): Promise<void> {
    this.submitting = true;
    try {
      await this.setAdjustmentNeedsDesignControllerRequestService.setAdjustmentNeedsDesign(
        this.adjustment.id,
        this.selectedDesigner == null ? null : this.selectedDesigner.id,
        this.selectedDeadline,
        this.needsDesignDescription
      );
      this.adjustment.needsDesign = true;
      this.adjustment.adjustmentDesigner = this.selectedDesigner;
      this.adjustment.currentDesignDate = this.selectedDeadline;
      this.adjustment.extraInfoDesign = this.needsDesignDescription;
      this.adjustment.designSentToCustomer = false;
      this.adjustment.designSentLog = null;
      this.adjustment.designApprovalRegistration = null;
      this.adjustment.designApproved = null;
      this.adjustment.designFinished = false;

      this.close.emit(true);
    } finally {
      this.submitting = false;
    }
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }
}
